var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full quotes-app"},[_c('TitleBar',{attrs:{"portal":_vm.portal}},[_vm._v("\n    Volumetric Rendering\n  ")]),_vm._v(" "),_c('div',{staticClass:"content-div",on:{"click":function($event){_vm.$emit('activated')}}},[_c('Volumetric')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-589ccd02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Apps/VolumetricApp/index.vue
// module id = null
// module chunks = 